import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The bliss and curse of mindsets",
  "description": "",
  "published": "2010-03-15T00:00:00.000Z",
  "redirect_from": ["/blog/the-bliss-and-curse-of-mindsets/swizec/1250"],
  "categories": "Education, life, Mathematics, Research, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:GodfreyKneller-IsaacNewton-1689.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/03/300px-GodfreyKneller-IsaacNewton-1689.jpg",
              "alt": "Isaac Newton",
              "title": "Isaac Newton"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:GodfreyKneller-IsaacNewton-1689.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Have you ever noticed how sometimes a difficult task suddenly becomes childplay? Incredibly easy? Painfully simplistic?`}</p>
    <p>{`This sometimes happens to me and it's a phenomena so awesome I just had to have a ponder about it. Just why the fuck does that happen?`}</p>
    <p>{`Personally I notice this effect mostly when I'm studying mathematics. For some reason advanced maths just comes incredibly hard for me, I have a fuzzy mind and maths requires one of those surgically clean minds. But after doing maths on and off all day, BAMF!, suddenly, even stumbling upon a problem I've never seen, it is just soooo very clear in my mind.`}</p>
    <p>{`Suddenly I can see complex vector spaces, I can imagine how functions behave in a hyper space, dare I say it, I can even understand how to convert a stupid point and lien to a plane. Yes! Yes I can!`}</p>
    <p>{`And it's all because my mindset switches to mathematics and that's a wonderful thing because it makes me feel I might actually pass that exam on Tuesday.`}</p>
    <p>{`But there's a very very dark side to these awesome mindset thingies.`}</p>
    <p>{`It's when you've got two or three completely different things that need to be done that come from completely different fields. Like when work deadlines and exams start playing in the same week and disturbing one another.`}</p>
    <p>{`Horrible really, because now you're faced with a decision: Do you spend another hour or two switching from maths mindset to business mindset and risk not getting the maths mindset back quickly enough. Or do you risk clearing your whole schedule for that exam and then hope you can get the other mindset back in time for that other deadline?`}</p>
    <p>{`I mostly tend to choose the maths, it feels much cooler.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/44940793-8c2f-42d0-953b-c7d084d5a86c/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=44940793-8c2f-42d0-953b-c7d084d5a86c",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      